import { FormDescription } from "../../../../../../common/Atoms/FormDescription";
import { FormLabel } from "../../../../../../common/Atoms/FormLabel";
import { fieldIsValid } from "../../../../../lib/helper";
import { Assignee, RECORD_ASSIGNEE } from "../../../../Common/Assignee";

import { IFieldProps } from "./fieldProps";

export function DefaultAssignee({
  policyFormData,
  invalids,
  handleChange,
}: IFieldProps) {
  return (
    <div className={ `w-full` }>
      <FormLabel>
        { `Assigned User` }
      </FormLabel>
      <FormDescription>
        { `Which user to assign the raised escalation to. Invoice or Contact Owner uses the invoice assignee, then the contact assignee.` }
      </FormDescription>
      <Assignee
        current={ policyFormData.assign_to_record_assignee ? RECORD_ASSIGNEE : policyFormData.assignee_user_id || null }
        allowRecordAssignee
        onChange={ value =>
          handleChange({
            name: `assignee_user_id`,
            value,
          })
        }
        invalid={ fieldIsValid(`assignee_user_id`, invalids) }
      />
    </div>
  );
}
